import React from 'react';
import { Modal, Button, Typography } from 'antd';

interface ExcelRowErrorModalProps {
  rowErrors: any[];
  selectedRowNum: number;
  setRowNum: (rowNum: number) => void;
  nameLabelMap: any;
}

const { Text } = Typography;

const ExcelRowErrorModal: React.FC<ExcelRowErrorModalProps> = ({
  rowErrors,
  selectedRowNum,
  setRowNum,
  nameLabelMap
}) => {
  const errors = rowErrors[selectedRowNum - 1] || {};
  const errorKeys = Object.keys(errors);

  const handleClose = () => {
    setRowNum(0);
  };

  return (
    <Modal
      title={`Row ${selectedRowNum} Errors`}
      open={selectedRowNum > 0}
      onCancel={handleClose}      // ✅ added here
      footer={[
        <Button key="close" onClick={handleClose}>
          Close
        </Button>,
      ]}
    >
      {errorKeys.length > 0 ? (
        <ul>
          {errorKeys.map((key: any) => (
            <li key={key}>
              <Text type="danger">
                <strong>{nameLabelMap[key] || key}:</strong> {key ? errors[key] : ""}
              </Text>
            </li>
          ))}
        </ul>
      ) : (
        <p>No errors found.</p>
      )}
    </Modal>
  );
};

export default ExcelRowErrorModal;
